export default "__VITE_ASSET__CHSaoLyA__"